import { forwardRef, useEffect, useRef, useState } from 'react';
import FilesServiceEdit from './FilesServiceEdit';
import { Select } from 'antd';
import BaseWebUniversal, { BaseWebUniversalProps } from '../system/BaseWebUniversal';
import { columnsheadId } from '../system/columnshead';
import fetchApi from '../system/fetchApi';
import getList from '../../universal/getList';
import { CommonProps } from '../../../utilsTs/declareTypes';
import { useMergedRef } from '../hooks/general';

export interface BaseFilesServiceProps extends Pick<BaseWebUniversalProps, 'defaultService' | 'displayOptions' | 'editOptions' | 'sendPageData'>,
    Pick<CommonProps, 'closeModal'> {
};

const BaseFilesService = forwardRef<any, BaseFilesServiceProps>((props, ref) => {
    const internalRef = useRef<any>(undefined);
    /** 合并外部 ref 和内部 refLocal */
    const mergedRef = useMergedRef(internalRef, ref);
    const { defaultService, sendPageData,
    } = props;
    const apiId = 'filesService';
    const [filesServerData, setFilesServerData] = useState<any>();
    const [selectedServerId, setSelectedServerId] = useState<string | undefined>(undefined);

    useEffect(() => {
        const { filesServerId } = sendPageData || {};
        if (filesServerId) {
            setSelectedServerId(filesServerId);
        }
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'filesServer',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setFilesServerData(res.data);
                    for (const item of res.data) {
                        const { id, isDefault } = item;
                        if (isDefault === true) {
                            if (!filesServerId) {
                                setSelectedServerId(id);
                            }
                            break;
                        }
                    }
                }
            })
    }, []);

    /**
     * 表头内容
     */
    const columnsHead = [
        {
            title: '服务名称',
            dataIndex: 'serviceName',
            sorter: true
        }
    ];

    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);

    /** 扩展Props */
    let extendProps: BaseWebUniversalProps = {
        ...props,
        titleName: '服务号',
        apiId,
        columns,
        editOptions: {
            Editor: FilesServiceEdit
        },
        renderHeadExtra: ({ rows, fetchData }) => (
            <>
                <Select
                    showSearch
                    placeholder="服务器"
                    optionFilterProp="children"
                    value={selectedServerId}
                    onChange={(e) => {
                        setSelectedServerId(e);
                        if (fetchData) {
                            fetchData({
                                apiId,
                                sendPageData: { filesServerId: e }
                            });
                        }
                    }}
                    style={{ width: 130 }}
                    filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {getList.general(filesServerData, {
                        itemName: 'serverName'
                    })}
                </Select>
            </>
        )
    };

    return (
        <>
            <BaseWebUniversal {...extendProps} ref={mergedRef} />
        </>
    )
});

export default BaseFilesService;